var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFecha = function SvgFecha(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.625 86.595",
    enableBackground: "new 0 0 86.625 86.595",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000093150706935795862800000004963506846122047659_",
    cx: 43.248,
    cy: 43.14,
    r: 42.671
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052798508899616900220000014550120502729804672_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093150706935795862800000004963506846122047659_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.578,
    y: 0.47,
    clipPath: "url(#SVGID_00000052798508899616900220000014550120502729804672_)",
    fill: "#E6F8F8",
    width: 85.342,
    height: 85.342
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000052798508899616900220000014550120502729804672_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.241,
    y: 28.251,
    fill: "#B1137C",
    width: 35.563,
    height: 35.566
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.804,
    y: 28.251,
    fill: "#D298BF",
    width: 8.453,
    height: 35.566
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M32.827,34.284c0,1.241-1.004,2.247-2.244,2.247c-1.245,0-2.25-1.005-2.25-2.247 c0-1.243,1.005-2.249,2.25-2.249C31.823,32.036,32.827,33.041,32.827,34.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M53.501,34.284c0,1.241-1.007,2.247-2.249,2.247c-1.239,0-2.246-1.005-2.246-2.247 c0-1.243,1.007-2.249,2.246-2.249C52.493,32.036,53.501,33.041,53.501,34.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M51.248,35.284c-2.637,0-4.778-2.145-4.778-4.779v-3.259c0-2.637,2.141-4.782,4.778-4.782h6.001 c2.634,0,4.781,2.146,4.781,4.782v1.004h-2.002v-1.004c0-1.533-1.248-2.781-2.78-2.781h-6.001c-1.526,0-2.778,1.248-2.778,2.781 v3.259c0,1.531,1.251,2.78,2.778,2.78V35.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M30.583,35.284c-2.643,0-4.787-2.145-4.787-4.779v-3.259c0-2.637,2.145-4.782,4.787-4.782h5.995 c2.638,0,4.784,2.146,4.784,4.782v1.004h-2.004v-1.004c0-1.533-1.25-2.781-2.78-2.781h-5.995c-1.536,0-2.786,1.248-2.786,2.781 v3.259c0,1.531,1.25,2.78,2.786,2.78V35.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.278,45.895h1.887c1.493,0,2.236-0.729,2.236-2.192c0-0.568-0.175-1.03-0.534-1.392 c-0.352-0.359-0.857-0.538-1.502-0.538c-0.528,0-0.986,0.156-1.38,0.461c-0.392,0.311-0.584,0.693-0.584,1.151h-3.99 c0-0.908,0.248-1.718,0.755-2.426c0.509-0.714,1.208-1.271,2.102-1.668c0.895-0.398,1.881-0.599,2.957-0.599 c1.916,0,3.426,0.439,4.522,1.313c1.098,0.879,1.647,2.087,1.647,3.614c0,0.742-0.227,1.441-0.677,2.104 c-0.454,0.656-1.12,1.193-1.987,1.604c0.919,0.332,1.634,0.834,2.154,1.511c0.522,0.673,0.784,1.511,0.784,2.503 c0,1.541-0.592,2.774-1.778,3.694c-1.184,0.926-2.738,1.388-4.665,1.388c-1.131,0-2.176-0.213-3.15-0.648 c-0.966-0.427-1.697-1.021-2.192-1.788c-0.503-0.763-0.747-1.625-0.747-2.596h4.017c0,0.527,0.212,0.985,0.637,1.373 c0.426,0.387,0.954,0.583,1.576,0.583c0.702,0,1.266-0.2,1.683-0.589c0.418-0.391,0.624-0.89,0.624-1.497 c0-0.871-0.211-1.484-0.647-1.847c-0.433-0.365-1.035-0.547-1.8-0.547h-1.947V45.895z"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFecha, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fecha.cb52e03f.svg";
export { ForwardRef as ReactComponent };